import { Component } from '@angular/core';
import { map, switchMap } from 'rxjs';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { MasterDB } from 'src/app/DAO/MasterDB';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { Estacion, Negocios, RelacionUsuario, Rol, Usuario, UsuarioConfig, UsuarioNombreIdEmpleadoDTO } from 'src/app/types/Entitys';
import { CatNegocio, SubMenu } from 'src/app/types/type';
declare var $: any

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css'],
})
export class UsuariosComponent {
  collection: Usuario[];
  catalogoRoles: Rol[];
  negocios: Negocios[];
  estaciones: Estacion[];
  roles: Rol[];
  usuarioConfig: UsuarioConfig;
  subMenus: SubMenu[];
  page: number = 2;
  loadRows = false;
  btnBuscarEnabled: boolean = false;
  idEmpleado: number;

  constructor(private userService: UsuariosService) { }

  async ngOnInit() {
    this.loadSubMenu();

    this.idEmpleado = (await this.userService.getUsuario()).IdEmpleado;

    this.userService.fetchLoadInit(this.idEmpleado)
      .subscribe(results => {
        const [usuarios, negocios, roles] = results
        if (usuarios?.Result?.Exito)
          this.collection = usuarios.Result.Data as Usuario[]
        else
          Utilerias.alertClient('', usuarios?.Result?.Error, 1);

        if (negocios?.Result?.Exito)
          this.negocios = negocios.Result.Data as CatNegocio[]
        else
          Utilerias.alertClient('', negocios?.Result?.Error, 1);

        if (roles?.Result?.Exito)
          this.catalogoRoles = roles.Result.Data as Rol[]
        else
          Utilerias.alertClient('', roles?.Result?.Error, 1);
      });
  }

  datetimeToDateFormat(input: string) {
    return Utilerias.datetimeToDateFormat(input);
  }

  async bajaUsuario(idEmpleado: number) {
    const confirm = await Utilerias.alertConfirm(
      "Estas seguro de aplicar la baja, el usuario ya no podra seguir operando en el sistema."
    );
    if (confirm.value) {
      const usuarioSesion = await MasterDB.getUsuarioSesion(
        new EstacionesTVADB()
      );

      if (usuarioSesion.Roles[0].IdRol === 6)
        return Utilerias.alertClient(
          "No se puede realizar esta acción.",
          "No se puede dar de baja al usuario.",
          1
        );

      this.userService.postBajaUsuario({
        idEmpleado: idEmpleado,
        idEmpleadoSesion: usuarioSesion.IdEmpleado,
      })
        .pipe(
          switchMap(
            user => this.userService.getUsuarios({
              idEmpleado: this.idEmpleado,              
            })
              .pipe(
                map(usuarios => {
                  if (user?.Result?.Data)
                    return usuarios

                  return null
                })
              )
          )
        )
        .subscribe((usuarios) => {
          if (usuarios?.Result?.Exito) {
            this.collection = usuarios.Result.Data as Usuario[]
            Utilerias.alertClient("Baja aplicada.", "El usuario se dio de baja correctamente.", 2);
          }
          else
            Utilerias.alertClient('', usuarios?.Result?.Error, 1);
        });
    }
  }

  addUsuarioRegion(IdEmpleado: number, Nombre: string) {
    this.userService.getRelacionUsuario(IdEmpleado)
      .subscribe((usuario) => {
        if (usuario?.Result?.Exito && usuario?.Result?.Data) {
          const data = usuario.Result.Data as RelacionUsuario

          this.usuarioConfig = {
            IdEmpleado,
            Nombre,
            IdNegocio: data.IdNegocio,
            IdRegion: data.IdRegion,
            IdEstacion: data.IdEstacion,
            IdRol: data.IdRol
          }
        } else {
          this.usuarioConfig = {
            IdEmpleado,
            Nombre,
            IdNegocio: null,
            IdRegion: null,
            IdEstacion: null,
            IdRol: null
          }
        }
        $("#modalRelacionRegion").modal('show');
      })
  }

  loadUsers() {
    this.loadRows = true;
    this.userService.getUsuarios({
      idEmpleado: this.idEmpleado,
      page: this.page++
    })
      .subscribe(response => {
        if (response.Result.Exito) {
          const users = response.Result.Data as Usuario[]
          this.collection = [...this.collection, ...users]
          this.loadRows = false;
          if (users.length === 0)
            this.page--
        }
      })
  }

  searchUser(nombreIdEmpleado: string) {
    this.loadRows = true;
    this.btnBuscarEnabled = true;
    this.userService.getUsuariosByIdNombreEmpleado({
      idEmpleado: this.idEmpleado,
      nombreIdEmpleado
    })
      .subscribe(response => {
        if (response.Result.Exito) {
          const users = response.Result.Data as Usuario[]
          this.collection = users
          this.page = 1;
          this.loadRows = false;
          this.btnBuscarEnabled = false;
        }
      })
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: "Tipos de revisiones",
        router: '../../Configuracion',
        class: "submenu__item d-flex align-items-center",
      },
      {
        active: true,
        child: false,
        label: "Usuarios",
        class: "submenu__item submenu--active d-flex align-items-center",
      },
    ];
    this.subMenus = items;
  }
}
